import PropTypes from 'prop-types';
import React, { PureComponent, Fragment } from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './SchoolProgramInfo.scss';
import Accordion from '../Accordion';
import DiaIcon from '../icons/DiversityInAdmissions';
import SchoolDataSimple from '../SchoolDataSimple';
import { saveApplication } from '../../actions/saveApplication';
import { saveProgram } from '../../actions/saveProgram';
import messages from '../../locale/messages';
import analytics from '../../services/analytics';
import {customisedIntlFormatMessage} from '../../utils/helpers';

const localMessages = defineMessages({
  preferencesTitle: {
    id: 'schoolprograminfo.preferences.title',
    defaultMessage: 'Preference is given to the following students',
    description: 'which students preference is given to',
  },
  stringAuditionInformationAndSchedule: {
    id: 'schoolprograminfo.auditioninformationandschedule.title',
    defaultMessage: 'Audition Information and Schedule',
    description: 'Information and scheduling title for student auditions',
  },
  stringAuditionSchedule: {
    id: 'schoolprograminfo.auditionschedule.title',
    defaultMessage: 'Audition Schedule',
    description: 'Scheduling title for student auditions',
  },
  stringAuditionInformation: {
    id: 'schoolprograminfo.auditioninformation.title',
    defaultMessage: 'Audition Information',
    description: 'Information title for student auditions',
  },
  stringAdmissionsMethod: {
    id: 'schoolprograminfo.stringAdmissionsMethod.title',
    defaultMessage: 'Admissions Method',
    description: 'Information title Admissions Method',
  },
});

class SchoolProgramInfo extends PureComponent {
  static defaultProps = {
    description: '',
    eligible: null,
    interest_areas: [],
  };
  static propTypes = {
    admissionMethod: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
    }).isRequired,
    description: PropTypes.string,
    demand_last_year: PropTypes.shape({
      general_education: PropTypes.shape({
        applications_per_seat: PropTypes.number,
        seats: PropTypes.number,
        applicants: PropTypes.number,
        seats_description: PropTypes.string,
        all_seats_filled: PropTypes.bool,
      }),
      students_with_disabilities: PropTypes.shape({
        applications_per_seat: PropTypes.number,
        seats: PropTypes.number,
        applicants: PropTypes.number,
        seats_description: PropTypes.string,
        all_seats_filled: PropTypes.bool,
      }),
      specialized_education: PropTypes.shape({
        applications_per_seat: PropTypes.number,
        seats: PropTypes.number,
        applicants: PropTypes.number,
        all_seats_filled: PropTypes.bool,
      }),
    }).isRequired,
    eligibility_description: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    getPriorityGroups: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    likelihood: PropTypes.string.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    lowest_priority: PropTypes.string.isRequired,
    performance: PropTypes.string.isRequired,
    preference: PropTypes.string.isRequired,
    program: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    saveProgram: PropTypes.func.isRequired,
    saved: PropTypes.bool.isRequired,
    // savedProgramId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    savedApplication: PropTypes.bool.isRequired,
    saveApplication: PropTypes.func.isRequired,
    selection_criteria: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ).isRequired,
    selection_criteria_note: PropTypes.string.isRequired,
    school: PropTypes.shape({
      dbn: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    schoolId: PropTypes.number.isRequired,
    user: PropTypes.shape({
      applicationId: PropTypes.string.isRequired,
      isMS: PropTypes.bool,
      isK: PropTypes.bool,
    }).isRequired,
    intl: PropTypes.shape().isRequired,
    program_priority_groups: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ).isRequired,
    seats_10th_available: PropTypes.bool.isRequired,
    interest_areas: PropTypes.arrayOf({
      name: PropTypes.string,
    }),
    eligible: PropTypes.bool,
    admissionProcess: PropTypes.string.isRequired,
    diversity_in_admission_1: PropTypes.string,
    diversity_in_admission_2: PropTypes.string,
    testing_not_registered: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    let is_swd = false;
    let switches = null;
    if (props.loggedIn) {
      switches = props.switchsGeSwd || props.switches;
      is_swd = switches && switches.show_GE_SWD_toggle_on_application_program_admissions && switches.is_swd
    }

    this.state = {
      isSWDSelected: switches && switches.is_swd,
      showGEDemandSection: !is_swd,
      showSWDDemandSection: is_swd
    };
  }
  accordionClick = accordionLabel => {
    const { school, program, loggedIn } = this.props;
    const { code, name } = program;
    let dataDictionary = {
      accordionLabel: accordionLabel,
      programName: `${name}`,
      programCode: `${code}`,
      schoolName: `${school.name}`,
      schoolDbn: `${school.dbn}`,
      loggedIn: loggedIn ? true : false
    };
    if(this.props.user.show_loo_tooltip){
      const { loo_chances } = this.props;
      dataDictionary['looIndicator'] = loo_chances || 'NOT_AVAIL_PROB';
    }
    analytics({
      eventLabel: 'programAccordionOpen',
      dataDictionary: dataDictionary
    });
  };

  assumeIndefiniteArticle = name => {
    const vowels = 'aeiou';

    if (vowels.indexOf(name[0]) > -1) return `an ${name}`;
    return `a ${name}`;
  };

  renderPriorityGroup = () => {
    const { getPriorityGroups, admissionMethod, preference, user } = this.props;
    const isLimitedUnscreened = admissionMethod.name === 'Limited Unscreened';
    const { all, forStudent } = getPriorityGroups();
    const isLoggedInHsMS = user.isMS || user.isHS;

    if (!all || (all.filter(priority => priority.name).length === 0 && !preference)) {
      return null;
    } else if (!all || all.filter(priority => priority.name).length === 0) {
      return <div className={style.priorityGroups}>{this.renderPreference()}</div>;
    }

    let show_priority_group_info = false;
    if (this.props.loggedIn) {
      const switches = this.props.switchsGeSwd || this.props.switches;
      show_priority_group_info = !isLoggedInHsMS || switches.show_GE_SWD_toggle_on_application_program_admissions || switches.show_GE_SWD_toggle_on_public_program_admissions
    }

    const priorityGroups = all.map(priority => {
      // if (priority.order === forStudent && !isLimitedUnscreened) {
      //   return (
      //     <li key={`priority-accordion-${priority.id}`}>
      //       <div className={style.priorityGroupListItemTitle}>
      //         <FormattedMessage {...messages.generalStringYourGroup} />
      //       </div>
      //       <div>{priority.name}</div>
      //       {priority.description && <div>({priority.description})</div>}
      //     </li>
      //   );
      // }
      let description;
      if (this.state.isSWDSelected) {
        description = priority.swd_priority_group_description;
      } else {
        description = priority.ge_priority_group_description;
      }
      return (
        <li className={style.priorityGroupListItem} key={`priority-accordion-${priority.id}`}>
          <div>{priority.name}</div>
          {description && show_priority_group_info && <div>({description})</div>}
        </li>
      );
    });
    return (
      <div className={style.priorityGroups}>
        <div className={style.priorityGroupsHeader}>
          <FormattedMessage {...messages.generalStringPriorityGroup} tagName={'span'} />
        </div>
        {isLimitedUnscreened && (
          <div className={style.limitedUnscreenedMessage}>
            <FormattedMessage {...messages.schoolProgramLimitedUnscreened} />
          </div>
        )}
        <ol className={style.priorityGroupsList}>{priorityGroups}</ol>
        {this.props.lowest_priority && <p className={style.admissionsProcessText}>{this.props.lowest_priority}</p>}
        {this.renderPreference()}
      </div>
    );
  };

  renderPreference = () => {
    const { preference } = this.props;
    if (preference) {
      return (
        <Fragment>
          <div className={style.priorityGroupsHeader}>
            <FormattedMessage {...localMessages.preferencesTitle} />
          </div>
          <div>
            <p className={style.admissionsProcessText}>{this.props.preference}</p>
          </div>
        </Fragment>
      );
    }

    return null;
  };

  renderProgramPriorityGroups = () => {
    const programPriorityGroups = this.props.program_priority_groups;
    const { preference } = this.props;
    if (
      !programPriorityGroups ||
      (programPriorityGroups.filter(priority => priority.name).length === 0 && !preference)
    ) {
      return null;
    } else if (!programPriorityGroups || programPriorityGroups.filter(priority => priority.name).length === 0) {
      return <div className={style.priorityGroups}>{this.renderPreference()}</div>;
    }
    const priorityGroups = programPriorityGroups.map(priority => {
      let description;
      if (this.state.isSWDSelected) {
        description = priority.swd_priority_group_description;
      } else {
        description = priority.ge_priority_group_description;
      }
      return (
        <li key={`priority-accordion-${priority.id}`}>
          <div>{priority.name}</div>
          {description && <div>({description})</div>}
        </li>
      )
    });
    return (
      <div className={style.priorityGroups}>
        <div className={style.priorityGroupsHeader}>
          <FormattedMessage {...messages.generalStringProgramPriorityGroup} />
        </div>
        <ol className={style.priorityGroupsList}>{priorityGroups}</ol>
        {this.props.lowest_priority && <p className={style.admissionsProcessText}>{this.props.lowest_priority}</p>}
        {this.renderPreference()}
      </div>
    );
  };

  renderDemand = (demand, type = '') => {
    let allSeats;

    if (demand.all_seats_filled === false) {
      allSeats = <FormattedMessage {...messages.generalStringNotAllSeatsFilled} />;
    } else if (demand.all_seats_filled === true) {
      allSeats = <FormattedMessage {...messages.generalStringAllSeatsFilled} />;
    }
    return (
      <div className={style.demand}>
        <div className={style.demandBody}>
          {demand.applications_per_seat && (
            <div className={style.demandItemFirst}>
              <span className={style.demandRowOne}>{demand.applications_per_seat}</span>
              <span className={style.demandRowTwo}>
                <FormattedMessage {...messages.generalStringApplicationsPerSeat} />
              </span>
            </div>
          )}
          {demand.seats && (
            <div className={style.demandItem}>
              <span className={style.demandRowOne}>{demand.seats}</span>
              <span className={style.demandRowTwo}>
                <FormattedMessage {...messages.generalStringSeats} />
              </span>
            </div>
          )}
          {demand.applicants && (
            <div className={style.demandItem}>
              <span className={style.demandRowOne}>{demand.applicants}</span>
              <span className={style.demandRowTwo}>
                <FormattedMessage {...messages.generalStringApplicants} />
              </span>
            </div>
          )}
          {demand.seats_description && (
            <div className={style.demandItem}>
              <span className={style.demandRowTwo}>{demand.seats_description}</span>
            </div>
          )}
          <div className={style.demandItem}>
            <span className={style.demandRowTwo}>{allSeats}</span>
          </div>
        </div>
      </div>
    );
  };

  renderSelectionCriteria = () => {
    const selectionCriteriaList = this.props.selection_criteria;
    const { name, name_en } = this.props.admissionMethod;
    const note = this.props.selection_criteria_note;

    if (!selectionCriteriaList.length) {
      return null;
    }

    const selectionCriteria = selectionCriteriaList.map(indCriteria => (
      <li
        className={style.selectionCriteriaListItem}
        key={`${indCriteria.name}-accordion`}
        dangerouslySetInnerHTML={{ __html: indCriteria.name }}
      />
    ));
    return (
      <div className={style.selectionCriteria}>
        <div className={style.selectionCriteriaHeader}>
          <FormattedMessage {...messages.generalStringSelectionCriteria} />
        </div>
        <div className={style.selectionCriteriaDescription}>
          {
            name == 'Screened With Assessment' || name_en == 'Screened With Assessment' ?
              <FormattedMessage {...messages.schoolProgramSelectionCriteriaDescription1} /> :
              <FormattedMessage
                {...messages.schoolProgramSelectionCriteriaDescription}
                values={{ name: this.assumeIndefiniteArticle(name.toLowerCase()) }}
              />
          }
        </div>
        <ul className={style.selectionCriteriaList}>{selectionCriteria}</ul>
        {note && <div className={style.selectionCriteriaNote}>{note}</div>}
      </div>
    );
  };

  renderDiversityInAdmissions = () => {
    const { name } = this.props.admissionMethod;

    if (!this.props.diversity_in_admission_1 && !this.props.diversity_in_admission_2) {
      return null;
    }

    return (
      <div className={style.diversityInAdmissions}>
        <div className={style.diversityInAdmissionsHeader}>
          <DiaIcon fill="#E50A0A" size={35} style={{ marginRight: '5px' }} />
          <FormattedMessage {...messages.diversityInAdmissions} />
        </div>
        <div className={style.diversityInAdmissionsDescription}>
          <FormattedMessage
            {...messages.diversityInAdmissionsDescription}
            values={{ name: this.assumeIndefiniteArticle(name.toLowerCase()) }}
          />
        </div>
        <ul className={style.diversityInAdmissionsList}>
          {this.props.diversity_in_admission_1 &&
            this.props.diversity_in_admission_1.trim() && (
              <li
                className={style.diversityInAdmissionsListItem}
                dangerouslySetInnerHTML={{
                  __html: this.props.diversity_in_admission_1,
                }}
              />
            )}

          {this.props.diversity_in_admission_2 &&
            this.props.diversity_in_admission_2.trim() && (
              <li
                className={style.diversityInAdmissionsListItem}
                dangerouslySetInnerHTML={{
                  __html: this.props.diversity_in_admission_2,
                }}
              />
            )}
        </ul>
      </div>
    );
  };

  handleGESeatGroupEligibilityClick = () => {
    this.setState({
      ...this.state,
      isSWDSelected: false,
      showGEDemandSection: true,
      showSWDDemandSection: false
    });
  };

  handleSWDSeatGroupEligibilityClick = () => {
    this.setState({
      ...this.state,
      isSWDSelected: true,
      showGEDemandSection: false,
      showSWDDemandSection: true
    });
  };
  render() {
    const {
      loggedIn,
      program,
      admissionMethod,
      eligible,
      firstName,
      intl,
      user,
      admissionProcess,
      interest_areas: interestAreas,
      audition_information: auditionInformation,
      audition_schedule: auditionSchedule,
    } = this.props;
    const switches = this.props.switchsGeSwd || this.props.switches;
    // const { admissionMethod } = this.props;
    const { name, description } = admissionMethod;
    const isGT = program.admission_process === 'G&T Application'
    const isHsMs = program.is_ms || program.is_hs;
    const isShsLg = program.is_shs || program.is_lg;
    const isLoggedInHsMS = user.isMS || user.isHS;
    const generalEducation = this.props.demand_last_year.general_education;
    const studentsWithDisabilities = this.props.demand_last_year.students_with_disabilities;
    const specializedEducation = this.props.demand_last_year.specialized_education;
    const { showGEDemandSection, showSWDDemandSection } = this.state;
    let myChancesLabel;
    if (user.isMS || program.is_ms) {
      myChancesLabel = messages.generalStringProgramInformation;
    } else {
      myChancesLabel = messages.generalStringMyChances;
    }
    let renderDemandGE = true;
    let renderDemandSWD = true;
    let renderDemandSHS = true;
    let renderDescription = false;
    if (generalEducation && generalEducation.seats_description) {
      renderDescription = true;
    }
    if (
      generalEducation &&
      !generalEducation.applications_per_seat &&
      !generalEducation.seats &&
      !generalEducation.applicants &&
      ((!generalEducation.seats_description && !renderDescription) ||
        (generalEducation.seats_description && renderDescription)) &&
      !generalEducation.all_seats_filled
    ) {
      renderDemandGE = false;
    }
    if (
      studentsWithDisabilities &&
      !studentsWithDisabilities.applications_per_seat &&
      !studentsWithDisabilities.seats &&
      !studentsWithDisabilities.applicants &&
      !studentsWithDisabilities.seats_description &&
      !studentsWithDisabilities.all_seats_filled
    ) {
      renderDemandSWD = false;
    }
    if (
      specializedEducation &&
      !specializedEducation.applications_per_seat &&
      !specializedEducation.seats &&
      !specializedEducation.applicants &&
      !specializedEducation.all_seats_filled
    ) {
      renderDemandSHS = false;
    }
    let renderDemandSection = false;
    if (!isGT || (!user.isK && (renderDemandGE || renderDemandSWD || renderDemandSHS || renderDescription))) {
      renderDemandSection = true;
    }
    return (
      <div className={style.accordionContainer}>
        {this.props.eligibility_description &&
          !loggedIn && (
            <Accordion
              label={customisedIntlFormatMessage(intl, messages.generalStringEligibilityDescription)}
              analytics={this.accordionClick}
            >
              <div className={style.programDataWrapper}>{this.props.eligibility_description}</div>
            </Accordion>
          )}
        {!loggedIn ? (
          <Accordion
            superLabel={customisedIntlFormatMessage(intl, messages.generalStringAdmissionsMethod)}
            label=""
            analytics={this.accordionClick}
          >
            <div className={style.programDataWrapper}>
              <div>
                <div className={style.demand}>
                  {renderDemandSection && (<div className={style.demandBodyHeader}>
                     {isHsMs && (<>
                     <input
                        type="radio"
                        name={`seat_group_eligibility_${this.props.id}`}
                        value="YES"
                        id={`ge_priority_${this.props.id}`}
                        className={style.demandSelector}
                        onChange={this.handleGESeatGroupEligibilityClick}
                        checked={!this.state.isSWDSelected}
                      />
                      <label className={style.demandLabel} htmlFor={`ge_priority_${this.props.id}`}>
                        <FormattedMessage {...messages.generalStringGeneralEducation} />
                      </label>
                      </>)}
                      {isHsMs && switches && switches.show_GE_SWD_toggle_on_public_program_admissions && (<>
                        <input
                          type="radio"
                          name={`seat_group_eligibility_${this.props.id}`}
                          value="NO"
                          id={`swd_priority_${this.props.id}`}
                          className={style.demandSelector}
                          onChange={this.handleSWDSeatGroupEligibilityClick}
                          checked={this.state.isSWDSelected}
                        />
                        <label className={style.demandLabel} htmlFor={`swd_priority_${this.props.id}`}>
                          <FormattedMessage {...messages.generalStringStudentsWithDisabilities} />
                        </label>
                      </>)}
                    </div>
                  )}
                </div>
                {this.props.showSWDNote && <div className={style.notetext}><FormattedMessage values={{ i: (chunks) => <i>{chunks}</i>, strong: (chunks) => <strong>{chunks}</strong> }} { ...messages.generalStringStudentsNoteText} /></div>}
                <div className={style.flexContainer}>
                  {renderDemandSection && (
                    <>
                      {!isGT && (<div className={style.demandHeader}>
                        <FormattedMessage {...messages.generalStringDemandLastYear} />
                      </div>)}
                      {renderDescription && this.renderDemand(generalEducation, null)}
                      {renderDemandGE && showGEDemandSection && (
                        <div>
                          {this.renderDemand(
                            generalEducation,
                            customisedIntlFormatMessage(intl, messages.generalStringGeneralEducation),
                          )}
                        </div>
                      )}
                      {isHsMs && switches && switches.show_GE_SWD_toggle_on_public_program_admissions && (<>
                      {renderDemandSWD && showSWDDemandSection && (
                          <div>
                            {this.renderDemand(
                              studentsWithDisabilities,
                              customisedIntlFormatMessage(intl, messages.generalStringStudentsWithDisabilities),
                            )}
                          </div>
                        )}
                      </>)}
                      {isShsLg && (<>
                      {renderDemandSHS && <div>{this.renderDemand(specializedEducation)}</div>}
                      </>)}
                    </>
                  )}
                </div>
                <div>{this.renderProgramPriorityGroups()}</div>
                {this.renderDiversityInAdmissions()}

                <div className={style.demandHeader}>{customisedIntlFormatMessage(intl, myChancesLabel)}</div>
                <div className={style.programDataWrapper}>
                  {this.props.eligibility_description && (
                    <Fragment>
                      <div className={style.demandHeader}>
                        <FormattedMessage {...messages.generalStringEligibility} />
                      </div>
                      {loggedIn && !eligible && !program.is_ms && (
                        <div>
                          <strong>
                            <FormattedMessage
                              {...messages.generalStringStudentNotEligibleForProgram}
                              values={{ firstName }}
                            />
                          </strong>
                        </div>
                      )}
                      <p>{this.props.eligibility_description}</p>
                    </Fragment>
                  )}
                  {!this.props.eligibility_description &&
                    (<p>
                      <FormattedMessage values={{strong: (chunks) => <strong>{chunks}</strong> }} {...messages.schoolProgramToolTipTopParagraphGT} />
                    </p>)}
                </div>


                <div className={style.demandHeader}><FormattedMessage {...localMessages.stringAdmissionsMethod} /></div>
                <div className={style.demandSubHeader}>{name}</div>
                {!isGT &&
                  description &&
                  description.length !== 0 && (
                    <div className={style.programDataWrapper}>{admissionMethod.description}</div>
                  )}
                <div>{this.renderSelectionCriteria()}</div>
              </div>
            </div>
          </Accordion>
        ) : (
          <Accordion
            superLabel={customisedIntlFormatMessage(intl, messages.generalStringAdmissionsMethod)}
            label=""
            analytics={this.accordionClick}
          >
            <Accordion label={customisedIntlFormatMessage(intl, myChancesLabel)} analytics={this.accordionClick}>
              <div className={style.programDataWrapper}>
                {this.props.eligibility_description && (
                  <Fragment>
                    <div className={style.demandHeader}>
                      <FormattedMessage {...messages.generalStringEligibility} />
                    </div>
                    {loggedIn && !eligible && (
                      <div>
                        <strong>
                          <FormattedMessage
                            {...messages.generalStringStudentNotEligibleForProgram}
                            values={{ firstName }}
                          />
                        </strong>
                      </div>
                    )}
                    <p>{this.props.eligibility_description}</p>
                  </Fragment>
                )}
                {!this.props.eligibility_description &&
                  (isGT ? (
                    <p>
                      <FormattedMessage {...messages.schoolProgramToolTipTopParagraphGT} values={{ strong: (chunks) => <strong>{chunks}</strong> }} />
                    </p>
                  ) : (
                    <p>
                      <FormattedMessage {...messages.schoolProgramToolTipTopParagraph} values={{ strong: (chunks) => <strong>{chunks}</strong> }} />
                    </p>
                  ))}
                <div className={style.demand}>
                  {renderDemandSection && (
                    <>
                      <div className={style.demandBodyHeader}>
                        {isLoggedInHsMS && switches && switches.show_GE_SWD_toggle_on_application_program_admissions && (
                          <>
                            <input
                              type="radio"
                              name={`seat_group_eligibility_${this.props.id}`}
                              value="YES"
                              id={`ge_priority_${this.props.id}`}
                              className={style.demandSelector}
                              onChange={this.handleGESeatGroupEligibilityClick}
                              checked={!this.state.isSWDSelected}
                            />
                            <label className={style.demandLabel} htmlFor={`ge_priority_${this.props.id}`}>
                              <FormattedMessage {...messages.generalStringGeneralEducation} />
                            </label>
                            <input
                              type="radio"
                              name={`seat_group_eligibility_${this.props.id}`}
                              value="NO"
                              id={`swd_priority_${this.props.id}`}
                              className={style.demandSelector}
                              onChange={this.handleSWDSeatGroupEligibilityClick}
                              checked={this.state.isSWDSelected}
                            />
                            <label className={style.demandLabel} htmlFor={`swd_priority_${this.props.id}`}>
                              <FormattedMessage {...messages.generalStringStudentsWithDisabilities} />
                            </label>
                          </>
                        )}
                        {isLoggedInHsMS && switches && !switches.show_GE_SWD_toggle_on_application_program_admissions && (
                          <>
                            {switches && !switches.is_swd && <>
                              <input
                                type="radio"
                                name={`seat_group_eligibility_${this.props.id}`}
                                value="YES"
                                id={`ge_priority_${this.props.id}`}
                                className={style.demandSelector}
                                onChange={this.handleGESeatGroupEligibilityClick}
                                checked={!switches.is_swd}
                              />
                              <label className={style.demandLabel} htmlFor={`ge_priority_${this.props.id}`}>
                                <FormattedMessage {...messages.generalStringGeneralEducation} />
                              </label>
                            </>}
                            {switches && switches.is_swd && <>
                              <input
                                type="radio"
                                name={`seat_group_eligibility_${this.props.id}`}
                                value="NO"
                                id={`swd_priority_${this.props.id}`}
                                className={style.demandSelector}
                                onChange={this.handleSWDSeatGroupEligibilityClick}
                                checked={switches.is_swd}
                              />
                              <label className={style.demandLabel} htmlFor={`swd_priority_${this.props.id}`}>
                                <FormattedMessage {...messages.generalStringStudentsWithDisabilities} />
                              </label>
                            </>}
                          </>
                        )}
                      </div>
                      {this.props.showSWDNote && <div className={style.notetext}><FormattedMessage values={{ i: (chunks) => <i>{chunks}</i>, strong: (chunks) => <strong>{chunks}</strong> }} { ...messages.generalStringStudentsNoteText} /></div>}
                    </>
                  )}
                </div>

                {switches && switches.show_GE_SWD_toggle_on_application_program_admissions && <div className={style.flexContainer}>
                  {renderDemandSection && (
                    <>
                      <div className={style.demandHeader}>
                        <FormattedMessage {...messages.generalStringDemandLastYear} />
                      </div>
                      {renderDemandGE && showGEDemandSection && (
                        <div id={`ge_demand_${this.props.id}`}>
                          {this.renderDemand(
                            generalEducation,
                            customisedIntlFormatMessage(intl, messages.generalStringGeneralEducation),
                          )}
                        </div>
                      )}
                      {renderDemandSWD && showSWDDemandSection && (
                          <div id={`swd_demand_${this.props.id}`}>
                            {this.renderDemand(
                              studentsWithDisabilities,
                              customisedIntlFormatMessage(intl, messages.generalStringStudentsWithDisabilities),
                            )}
                          </div>
                        )}
                      {renderDemandSHS && <div>{this.renderDemand(specializedEducation)}</div>}
                    </>
                  )}
                </div>}

                {switches && !switches.show_GE_SWD_toggle_on_application_program_admissions && <div className={style.flexContainer}>
                  {renderDemandSection && (
                    <>
                      <div className={style.demandHeader}>
                        <FormattedMessage {...messages.generalStringDemandLastYear} />
                      </div>
                      {switches && !switches.is_swd && (
                        <div id={`ge_demand_${this.props.id}`}>
                          {this.renderDemand(
                            generalEducation,
                            customisedIntlFormatMessage(intl, messages.generalStringGeneralEducation),
                          )}
                        </div>
                      )}
                      {switches && switches.is_swd && (
                          <div id={`swd_demand_${this.props.id}`}>
                            {this.renderDemand(
                              studentsWithDisabilities,
                              customisedIntlFormatMessage(intl, messages.generalStringStudentsWithDisabilities),
                            )}
                          </div>
                        )}
                      {renderDemandSHS && <div>{this.renderDemand(specializedEducation)}</div>}
                    </>
                  )}
                </div>}

                <div>{this.renderPriorityGroup()}</div>
                {this.renderDiversityInAdmissions()}
                <div className={style.demandHeader}><FormattedMessage {...localMessages.stringAdmissionsMethod} /></div>
                <div className={style.demandSubHeader}>{name}</div>
                {!isGT &&
                  description &&
                  description.length !== 0 && <div className={style.programDataWrapper}>{description}</div>}
                {this.renderSelectionCriteria()}
              </div>
            </Accordion>
          </Accordion>
        )}
        {((auditionInformation && auditionInformation.length !== 0) ||
          (auditionSchedule && auditionSchedule.length !== 0)) && (
            <Accordion
              label={customisedIntlFormatMessage(intl, localMessages.stringAuditionInformationAndSchedule)}
              analytics={this.accordionClick}
            >
              <div className={style.selectionCriteria}>
                {auditionInformation &&
                  auditionInformation.length !== 0 && (
                    <div className={style.mb15}>
                      <div className={style.selectionCriteriaHeader}>
                        <FormattedMessage {...localMessages.stringAuditionInformation} />
                      </div>
                      <ul>
                        {auditionInformation.map(({ name, order }) => (
                          <li dangerouslySetInnerHTML={{ __html: sanitize_html(name) }} key={order} />
                        ))}
                      </ul>
                    </div>
                  )}
                {auditionSchedule &&
                  auditionSchedule.length !== 0 && (
                    <div className={style.mb15}>
                      <div className={style.selectionCriteriaHeader}>
                        <FormattedMessage {...localMessages.stringAuditionSchedule} />
                      </div>
                      <ul>
                        {auditionSchedule.map(({ name, order }) => (
                          <li dangerouslySetInnerHTML={{ __html: sanitize_html(name) }} key={order} />
                        ))}
                      </ul>
                    </div>
                  )}
              </div>
            </Accordion>
          )}
        <Accordion
          label={customisedIntlFormatMessage(intl, messages.generalStringAdditionalInformation)}
          analytics={this.accordionClick}
        >
          <div className={style.programDataWrapper}>
            {program.code && (
              <SchoolDataSimple title={customisedIntlFormatMessage(intl, messages.generalStringProgramCode)} stat={program.code} />
            )}
            {admissionProcess === 'HS' && (
              <SchoolDataSimple
                title={customisedIntlFormatMessage(intl, messages.generalStringSeats10thGrade)}
                stat={
                  this.props.seats_10th_available
                    ? customisedIntlFormatMessage(intl, messages.generalStringAvailable)
                    : customisedIntlFormatMessage(intl, messages.generalStringNotAvailable)
                }
              />
            )}
            {!user.isMS &&
              interestAreas &&
              interestAreas.length !== 0 && (
                <SchoolDataSimple title={customisedIntlFormatMessage(intl, messages.generalStringInterestArea)} stat={interestAreas} />
              )}
          </div>
        </Accordion>
      </div>
    );
  }
}

const mapState = ({ user, schools }) => ({ user, switchsGeSwd: schools.switches });
const mapDispatch = {
  saveProgram,
  saveApplication,
};

export { SchoolProgramInfo };
export default injectIntl(connect(mapState, mapDispatch)(withStyles(style)(SchoolProgramInfo)));
